import DOMPurify from 'dompurify';

// Titles may carry light formatting from the archive index. Everything else is
// stripped by a maintained allowlist sanitizer before reaching an HTML sink.
const SANITIZE_CONFIG = {
    ALLOWED_TAGS: ['sub', 'sup', 'i', 'em', 'b', 'strong'],
    ALLOWED_ATTR: [],
    ALLOW_DATA_ATTR: false,
    ALLOW_ARIA_ATTR: false,
    KEEP_CONTENT: true,
    RETURN_TRUSTED_TYPE: false
};

export const sanitizeTitle = (title) => {
    if (typeof title !== 'string' || !title) return '';

    return DOMPurify.sanitize(title, SANITIZE_CONFIG);
};

export const getTitleText = (title) => {
    const sanitizedTitle = sanitizeTitle(title);
    if (!sanitizedTitle) return '';

    const documentParser = new DOMParser();
    return documentParser.parseFromString(sanitizedTitle, 'text/html').body.textContent || '';
};
